import axios from 'axios';
import { wrapClient } from '../request';
import { OrganizationApi } from './components/OrganizationApi';
import { ProjectApi } from './components/ProjectApi';
import { ServiceIntegrationApi } from './components/ServiceIntegrationApi';
import { GitConfigApi } from './components/GitConfigApi';
import { BuildAppApi } from './components/BuildAppApi';

class TerraBff {
  private client = wrapClient(
    axios.create({
      baseURL: window.REACT_APP_TERRA_BFF_API_URL,
    })
  );

  project = new ProjectApi(this.client);
  organization = new OrganizationApi(this.client);
  serviceIntegration = new ServiceIntegrationApi(this.client);
  gitConfig = new GitConfigApi(this.client);
  buildApp = new BuildAppApi(this.client);
}

export default new TerraBff();
